/* eslint-disable react-hooks/exhaustive-deps */
// React
import { useEffect, useRef, useState } from "react";

// Utils
import ICONS from "../../../assets/Icons/index.js";
import TEXT from "../../../utils/globalText.js";

// Components
import CommonCalendar from "../../_utils/CommonCalendar/index.jsx";
import MultiSelectDropDownComponent from "../../_utils/CommonDropdown/MultiSelectDropdown/index.jsx";
import CommonTimePicker from "../../_utils/CommonDropdown/SetTime/index.jsx";
import SingleSelectDropDownComponent from "../../_utils/CommonDropdown/SingleSelectDropdown/index.jsx";
import CommonFileUpload from "../../_utils/CommonFileUpload/index.jsx";
import TextInputField from "../../_utils/CommonInputFields/TextInputField.jsx";
import CommonLayout from "../../_utils/CommonLayout/index.jsx";
import CommonQuantity from "../../_utils/CommonQuantity/index.jsx";
import CategorySelector from "../../_utils/TransactionCommonComponents/CategorySelector.jsx";
import CommonToggleCard from "../../_utils/TransactionCommonComponents/CommonToggleCard.jsx";
import Loader from "../../Loader/Index.jsx";
import { useSelector } from "react-redux";

const ReimbursementRequestTxnAdditionalDetails = (props) => {
  const categories = useSelector(
    (state) => state.sharedResources?.categoriesData?.categories,
  );
  //  useRef
  const dropdownRefs = useRef(null);

  const [isError] = useState(false);
  const [isArchive] = useState(false);

  const [beneAccountId] = useState(
    props?.txnPayLoad?.beneAccountId ? props?.txnPayLoad?.beneAccountId : null,
  );

  const unassignCategories = props?.categories.filter(
    (cat) => cat?.active === "Y",
  );
  const unassignlength = unassignCategories.filter(
    (unassignCategory) => !props?.categoryIds?.includes(unassignCategory.id),
  );
  //  useState
  const [dropdowns, setDropdowns] = useState({});

  //  Constants
  const { selectedCategory } = props;
  const currentYear = new Date().getFullYear();

  const years = Array.from(
    { length: currentYear - 1975 + 1 },
    (_, i) => 1975 + i,
  );

  const days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  //  Callbacks
  const formatDate = (date) => {
    return `${date.getDate()} ${date.toLocaleString("default", {
      month: "short",
    })}, ${date.getFullYear()}`;
  };
  const handleDateChange = (dates, key, name, type) => {
    const [start, end] = dates;

    props?.setStartDate((prev) => ({ ...prev, [key]: start || null }));
    props?.setEndDate((prev) => ({ ...prev, [key]: end || null }));
    const formattedValue = {
      start_date: start ? formatDate(start) : null,
      end_date: end ? formatDate(end) : null,
    };

    handleInputChange({
      target: {
        name,
        value: formattedValue,
        data_type: type,
      },
    });

    if (start && end) {
      props?.setShowDatePicker((prev) => ({ ...prev, [key]: false }));
    }
  };
  const closeDropdowns = () => {
    setDropdowns((prev) => {
      const newDropdowns = Object.keys(prev).reduce((acc, key) => {
        acc[key] = { ...prev[key], isOpen: false };
        return acc;
      }, {});
      return newDropdowns;
    });
  };

  //  useEffect
  useEffect(() => {
    const handleClickOutside2 = (event) => {
      if (
        dropdownRefs.current &&
        !dropdownRefs.current.contains(event.target)
      ) {
        let obj = {
          ...dropdowns,
          isOpen: false,
        };
        setDropdowns(obj);
      }
    };

    document.addEventListener("mousedown", handleClickOutside2);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside2);
    };
  }, []);

  const handleClearTime = (key, field) => {
    const { [field]: _, ...updatedData } = props?.additionalData;
    props?.setAdditionalData(updatedData);
    props?.setTxnPayLoad((prevState) => ({
      ...prevState,
      mergeCategory: prevState.mergeCategory?.map((item) =>
        item.data_type === "time" ? { ...item, value: "" } : item,
      ),
    }));
    props?.setTimeData((prev) => {
      const updated = { ...prev };
      delete updated[key];
      return updated;
    });
  };

  const handleToggle = (fieldName, data_type, value, name) => {
    let newStates = value || false;
    newStates = !newStates;

    handleInputChange({
      target: {
        name: fieldName,
        value: newStates,
        data_typeChan: data_type,
      },
    });
    if (newStates === false) {
      const updatedData = { ...props?.additionalData, [name]: "" };
      props?.setAdditionalData(updatedData);
    }
  };

  const handleQuantityChange = (value, fieldname, data_type, key) => {
    if (value < 0 || value.length > 15) {
      return;
    }

    props?.setQuantities((prev) => ({
      ...prev,
      [key]: value,
    }));

    handleInputChange({
      target: {
        name: fieldname,
        value: Number(value) || 0,
        data_typeChan: data_type,
      },
    });
  };
  const handleCategorySelect = (category) => {
    const categoryData = props?.categories.find(
      (cat) =>
        cat.name?.trim().toLowerCase() ===
        categories
          ?.find((x) => x.id === category)
          ?.name?.trim()
          .toLowerCase(),
    );
    if (selectedCategory?.name === category) {
      return;
    }
    props.setIsCategoryLoading(true);
    if (props?.txnPayLoad?.selectedCategory?.name === props?.catName) {
      props?.setCatSelect(false);
    }
    props?.setSelectedCategory(categoryData);
    props?.handleCategorySelect(categoryData);
    props?.setTxnPayLoad({
      ...props?.txnPayLoad,
      selectedCategory: categoryData,
    });
    props?.setAdditionalData({});
    props?.setSelectedValue({ from: "Select", to: "Select" });
    props?.setStartDate({});
    props?.setEndDate({});
    props?.setStartDateCal({});
    props?.setIsSingleDateSelected(false);
    props?.setHyperLink({});
    props?.setPreviewImages({});
    props?.setUploadedFiles({});
    props?.setTimeData({});
    props?.setQuantities({});
    props?.setSelectedValueMonth({});
    props.setTxnPayLoad((x) => {
      return {
        ...x,
        expenseType: undefined,
        date: undefined,
        uploadFile: undefined,
        description: undefined,
      };
    });
  };

  const handleTimeConfirm = (
    fieldname,
    data_type,
    hourShow,
    minuteShow,
    meridiemShow,
  ) => {
    handleInputChange({
      target: {
        name: fieldname,
        value: `${hourShow}:${minuteShow} ${meridiemShow}`,
        data_typeChan: data_type,
      },
    });
  };

  const handleConfirmCal = (fieldname, data_type, value, key) => {
    handleInputChange({
      target: {
        name: fieldname,
        value: formatDate(value),
        data_typeChan: data_type,
      },
    });
    props?.setIsSingleDateSelected(true);
  };

  const handleFileChange = (file, key, field) => {
    props?.setUploadedFiles((prev) => ({ ...prev, [key]: file }));

    if (file?.type?.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = () => {
        props?.setPreviewImages((prev) => ({ ...prev, [key]: reader.result }));
      };
      reader.readAsDataURL(file);
    }

    handleInputChange({
      target: {
        name: field?.name,
        value: file,
        data_typeChan: field?.data_type,
      },
    });
  };

  const handleChange = (value, field, key) => {
    props?.setHyperLink((prev) => ({
      ...prev,
      [key]: value,
    }));

    handleInputChange({
      target: {
        name: field.name,
        value: value,
        data_typeChan: field.data_type,
      },
    });
  };

  const clearField = (field, key) => {
    const { [field.name]: _, ...updatedData } = props?.additionalData;
    props?.setAdditionalData(updatedData);
    props?.setTxnPayLoad((prevState) => ({
      ...prevState,
      mergeCategory: prevState.mergeCategory?.map((item) =>
        item.data_type === "hyperlink" ? { ...item, value: "" } : item,
      ),
    }));
    props?.setHyperLink((prev) => {
      const updated = { ...prev };
      delete updated[key];
      return updated;
    });
  };

  const handleInputChange = (e, data_type) => {
    if (data_type === "numeric" && e.target.value.length > 15) return;
    if (e.preventDefault) e.preventDefault();

    const {
      name,
      value,
      data_type: data_typeChan,
    } = e.target || {
      name: e.name,
      value: e.value,
    };

    const field =
      props?.txnPayLoad?.selectedCategory?.configuration?.data?.find(
        (f) => f.name === name,
      );

    let updatedData = { ...props.additionalData };

    const isNonTrimmedType = [
      "date",
      "year",
      "toggle",
      "time",
      "quantity",
      "from_year_to_year",
      "month_year",
      "date_range",
      "multi_select_list",
      "upload",
    ].includes(data_typeChan);

    const trimmedValue =
      isNonTrimmedType || typeof value !== "string"
        ? value
        : value.replace(/^\s+/, "");

    if (field?.data_type === "month_year") {
      if (typeof value === "object" && value?.month && value?.year) {
        const monthNumber = (months.indexOf(value.month) + 1)
          .toString()
          .padStart(2, "0");

        updatedData[name] = `${monthNumber}/${value.year}`;
      } else if (typeof value === "string" && value.includes("/")) {
        updatedData[name] = value;
      }
    } else if (field?.data_type === "date_range") {
      if (typeof value === "string" && value.includes("-")) {
        const [start, end] = value.split("-").map((v) => v.trim());
        updatedData[name] = {
          start_date: start,
          end_date: end,
        };
      } else if (typeof value === "object") {
        updatedData[name] = value;
      }
    } else if (field?.data_type === "numeric") {
      if (trimmedValue === "" || /^\d+$/.test(trimmedValue)) {
        updatedData[name] = trimmedValue;
      }
    } else {
      updatedData[name] = trimmedValue;
    }

    props.setAdditionalData(updatedData);

    if (field?.data_type === "list") {
      setDropdowns((prev) => ({
        ...prev,
        [name]: {
          ...prev[name],
          selectedOption: trimmedValue,
        },
      }));
    }

    return;
  };

  useEffect(() => {
    if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "time"
    ) {
      const timeStr = props?.copyData?.value;
      const [hourShow, rest] = timeStr.split(":");
      const [minuteShow, meridiemShow] = rest.split(" ");

      handleTimeConfirm(
        props?.copyData?.title,
        props?.copyData?.data_type,
        hourShow,
        minuteShow,
        meridiemShow,
      );

      props?.setTimeData((prev) => {
        const key = `${props?.copyData?.title}_${props?.copyData?.data_type}`;
        return {
          ...prev,
          [key]: { hours: hourShow, minutes: minuteShow },
        };
      });

      props?.setCopyData({
        title: "",
        value: "",
        data_type: "",
      });
    } else if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "date"
    ) {
      handleInputChange({
        target: {
          name: props?.copyData?.title,
          value: props?.copyData?.value,
          data_typeChan: props?.copyData?.data_type,
        },
      });

      let data = new Date(props?.copyData?.value);

      props?.setStartDateCal((prev) => {
        const key = `${props?.copyData?.title}_${props?.copyData?.data_type}`;

        return {
          ...prev,
          [key]: data,
        };
      });

      props?.setCopyData({
        title: "",
        value: "",
        data_type: "",
      });
    } else if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "quantity"
    ) {
      handleQuantityChange(
        props?.copyData?.value || 0,
        props?.copyData?.title,
        props?.copyData?.data_type,
        `${props?.copyData?.title}_${props?.copyData?.data_type}`,
      );

      props?.setCopyData({
        title: "",
        value: "",
        data_type: "",
      });
    } else if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "toggle"
    ) {
      handleInputChange({
        target: {
          name: props?.copyData?.title,

          value: props?.copyData?.value,

          data_typeChan: props?.copyData?.data_type,
        },
      });

      props?.setCopyData({
        title: "",

        value: "",

        data_type: "",
      });
    } else if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "month_year"
    ) {
      handleInputChange({
        target: {
          name: props?.copyData?.title,

          value: props?.copyData?.value,

          data_typeChan: props?.copyData?.data_type,
        },
      });

      const [monthStr, yearStr] = props?.copyData?.value.split("/");

      const monthIndex = parseInt(monthStr, 10) - 1;

      const monthName = new Date(2000, monthIndex).toLocaleString("default", {
        month: "long",
      });

      const result = [monthName, parseInt(yearStr, 10)];

      props?.setSelectedValueMonth((prev) => {
        const key = `${props?.copyData?.title}_${props?.copyData?.data_type}`;

        return {
          ...prev,

          [key]: { month: result[0], year: result[1] },
        };
      });

      props?.setCopyData({
        title: "",

        value: "",

        data_type: "",
      });
    } else if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "from_year_to_year"
    ) {
      handleInputChange({
        target: {
          name: props?.copyData?.title,

          value: props?.copyData?.value,

          data_typeChan: props?.copyData?.data_type,
        },
      });

      props?.setSelectedValue((prev) => {
        const key = `${props?.copyData?.title}_${props?.copyData?.data_type}`;

        return {
          ...prev,

          [key]: {
            from: props?.copyData?.value?.from,

            to: props?.copyData?.value?.to,
          },
        };
      });

      props?.setCopyData({
        title: "",

        value: "",

        data_type: "",
      });
    } else if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "date_range"
    ) {
      props?.setCopyData({
        title: "",

        value: "",

        data_type: "",
      });
    }
  }, [props?.copyData]);

  useEffect(() => {
    return () => props.setIsCategoryLoading(false);
  }, [props.setIsCategoryLoading]);

  useEffect(() => {
    if (!props.additionalData) return;

    const storeData =
      props.txnPayLoad.selectedCategory?.configuration?.data?.map((val) => {
        const dataValue = props.additionalData[val?.name];

        if (dataValue !== undefined && dataValue !== "") {
          if (val?.data_type === "numeric") {
            const integerValue = parseInt(dataValue, 10);
            if (!isNaN(integerValue)) {
              return { ...val, value: integerValue };
            } else {
              return val;
            }
          } else {
            return { ...val, value: dataValue };
          }
        } else if (val?.data_type === "multi_select_list") {
          return { ...val, value: [] };
        } else if (val?.data_type === "toggle") {
          return { ...val, value: false };
        } else if (val?.data_type === "hyperlink") {
          return { ...val, value: "" };
        } else if (val?.data_type === "time") {
        } else if (val?.mandatory !== "Y") {
          return { ...val, value: "" };
        }

        return val;
      });

    props.setTxnPayLoad({
      ...props.txnPayLoad,
      mergeCategory: storeData,
    });

    const timer = setTimeout(() => {
      props.setIsCategoryLoading(false);
    }, 500);

    closeDropdowns();
    return () => clearTimeout(timer);
  }, [props.additionalData, props.txnPayLoad.selectedCategory]);

  const renderInputFields = () => {
    if (!selectedCategory) {
      return (
        <div className="text-left text-text-primary text-sm antialiased">
          Select a category to fetch the category-specific details.
        </div>
      );
    }
    if (
      !selectedCategory.configuration ||
      !selectedCategory.configuration.data ||
      selectedCategory.configuration.data.length === 0
    ) {
      return (
        <div className="text-left text-text-primary text-sm antialiased">
          {TEXT.ADDITIONAL_DETAILS_UNSUPPORTED}
        </div>
      );
    }

    return props?.txnPayLoad?.mergeCategory?.map((field, index) => {
      const isFieldRequired = field.mandatory === "Y";
      const optionalLabel = isFieldRequired ? "" : " (optional)";
      const fieldValue = props?.additionalData[field.name] || "";
      switch (field?.data_type) {
        case "string":
        case "numeric":
          return (
            <TextInputField
              placeholder={`${field.name}${optionalLabel}`}
              name={field.name}
              value={fieldValue || ""}
              fontKind="big"
              bgColor="var(--primary-card)"
              variant="default"
              fgColor="var(--text-primary)"
              adornment={
                props?.initialRefactorAdditionalDetail?.[field.name]?.isPaste
                  ?.value
                  ? ICONS?.PASTE_WHITE_GREEN_BG
                  : ""
              }
              onAdornmentClick={
                props?.initialRefactorAdditionalDetail?.[field.name]?.isPaste
                  ?.value &&
                (() => {
                  props?.setAdditionalData((prev) => ({
                    ...prev,
                    [field.name]:
                      props?.initialRefactorAdditionalDetail?.[field.name]
                        ?.isPaste?.value,
                  }));
                  props?.setInitialRefactorAdditionalDetail((prev) => ({
                    ...prev,
                    [field.name]: {
                      ...prev[field.name],
                      isPaste: {},
                    },
                  }));
                })
              }
              isFullWidth={true}
              onInput={(e) => handleInputChange(e, field?.data_type)}
            />
          );
        case "list":
          return (
            <div className="flex flex-col gap-gap-xs">
              <p className="text-text-secondary text-font-xs">{`${field.name}${optionalLabel}`}</p>
              <SingleSelectDropDownComponent
                options={field?.data || []}
                selected={field?.value || ""}
                setSelected={(val) =>
                  handleInputChange({
                    target: { name: field.name, value: val },
                  })
                }
                type="big"
                placeholder={TEXT?.SELECT}
                showSearch={false}
                disabled={field?.disabled}
                onOpen={() => props?.setShowDatePicker?.(true)}
                onClose={() => props?.setShowDatePicker?.(false)}
                isOpen={false}
              />
            </div>
          );
        case "hyperlink":
          const keyHyper = `${field.name}_${field.data_type}`;
          const currentValue = props?.hyperLink?.[keyHyper] || "";

          const pasteValue =
            props?.initialRefactorAdditionalDetail?.[field.name]?.isPaste
              ?.value;
          const showAdornment = currentValue !== "" || pasteValue;

          return (
            <TextInputField
              value={currentValue}
              onInput={(e) => handleChange(e.target.value, field, keyHyper)}
              placeholder={`${field.name}${optionalLabel}`}
              name={`${keyHyper}`}
              bgColor="var(--primary-card)"
              fgColor="var(--text-primary)"
              variant="default"
              isFullWidth={true}
              adornment={
                showAdornment
                  ? pasteValue
                    ? ICONS?.PASTE_WHITE_GREEN_BG
                    : ICONS.CLOSE
                  : ""
              }
              onAdornmentClick={
                pasteValue
                  ? () => {
                      handleChange(pasteValue, field, keyHyper);
                      props?.setInitialRefactorAdditionalDetail((prev) => ({
                        ...prev,
                        [field?.name]: {
                          ...prev[field?.name],
                          isPaste: {},
                        },
                      }));
                    }
                  : showAdornment
                    ? () => clearField(field, keyHyper)
                    : undefined
              }
            />
          );
        case "time":
          const keyTime = `${field.name}_${field.data_type}`;
          const currentValueHours = props?.timeData?.[keyTime]?.hours || "";
          const currentValueMinutes = props?.timeData?.[keyTime]?.minutes || "";

          let isTimeSelectedShowButton =
            currentValueHours !== "" &&
            currentValueMinutes !== "" &&
            field?.value !== undefined;
          return (
            <div className="w-width-full flex flex-col gap-gap-xs">
              <p
                className="font-normal text-font-xs capitalize"
                style={{
                  color: field?.value
                    ? "var(--text-primary)"
                    : "var(--text-secondary)",
                  textTransform: "capitalize",
                }}
              >
                {`${field.name}${optionalLabel}`}
              </p>
              <CommonTimePicker
                handleTimeConfirm={handleTimeConfirm}
                handleClearTime={handleClearTime}
                value={isTimeSelectedShowButton ? field?.value : ""}
                data_type={field?.data_type}
                fieldname={field.name}
                keyTime={keyTime}
                timeData={props?.timeData}
                setTimeData={props?.setTimeData}
              />
            </div>
          );
        case "day":
          return (
            <div className="flex flex-col gap-gap-xs">
              <p className="text-text-secondary text-font-xs">{`${field.name}${optionalLabel}`}</p>
              <SingleSelectDropDownComponent
                options={days}
                selected={field?.value || ""}
                setSelected={(value) =>
                  handleInputChange(
                    { target: { name: field?.name, value } },
                    field?.data_type,
                  )
                }
                type="big"
                placeholder={TEXT?.SELECT}
                showSearch={false}
                disabled={false}
                isOpen={false}
                onOpen={() => props?.setShowDatePicker?.(true)}
                onClose={() => props?.setShowDatePicker?.(false)}
              />
            </div>
          );
        case "toggle":
          return (
            <div className="flex flex-col gap-gap-xs">
              <p className="text-text-secondary text-font-xs">{`${field.name}${optionalLabel}`}</p>
              <CommonToggleCard
                description={field?.description}
                state={field?.value}
                isDisabled={field?.disabled}
                handleClick={() =>
                  handleToggle(
                    field?.name,
                    field?.data_type,
                    field?.value,
                    field?.name,
                  )
                }
              />
            </div>
          );
        case "month":
          return (
            <div className="flex flex-col gap-gap-xs">
              <p className="text-text-secondary text-font-xs">{`${field.name}${optionalLabel}`}</p>
              <SingleSelectDropDownComponent
                options={months}
                selected={field?.value || ""}
                setSelected={(value) =>
                  handleInputChange(
                    { target: { name: field?.name, value } },
                    field?.data_type,
                  )
                }
                type="big"
                placeholder={TEXT?.SELECT}
                showSearch={false}
                disabled={false}
                isOpen={false}
                onOpen={() => props?.setShowDatePicker?.(true)}
                onClose={() => props?.setShowDatePicker?.(false)}
              />
            </div>
          );
        case "upload":
          const key = `${field.name}_${field.data_type}`;
          const file = props?.uploadedFiles[key];
          return (
            <div className="flex flex-col gap-gap-xs">
              <p className="text-text-secondary text-font-xs">
                {`${field.name === "File" ? "Upload File" : field.name}${optionalLabel}`}
              </p>
              <CommonFileUpload
                id={key}
                files={file || []}
                setFiles={(selectedFile) => {
                  handleFileChange(selectedFile, key, field);
                }}
                isDisabled={false}
                type={
                  field?.data_type.toLowerCase() === "upload" ? "all" : "both"
                }
              />
            </div>
          );

        case "date":
          const keyDate = `${field.name}_${field.data_type}`;
          const currentValueDate = props?.startDateCal?.[keyDate] || "";
          return (
            <div className="flex flex-col gap-gap-xs">
              <p className="text-text-secondary text-font-xs">{`${field.name}${optionalLabel}`}</p>
              <CommonCalendar
                startDate={currentValueDate}
                selectionType="single"
                type="big"
                handleDateChange={(selectedDate) => {
                  handleConfirmCal(
                    field?.name,
                    field?.data_type,
                    selectedDate,
                    keyDate,
                  );
                }}
              />
            </div>
          );
        case "multi_select_list":
          return (
            <div className="flex flex-col gap-gap-xs">
              <p className="text-text-secondary text-font-xs">{`${field.name}${optionalLabel}`}</p>
              <MultiSelectDropDownComponent
                options={field?.data || []}
                selected={field?.value || []}
                setSelected={(newSelected) =>
                  handleInputChange({
                    target: {
                      name: field?.name,
                      value: newSelected,
                    },
                  })
                }
                isOpen={false}
                showSearch={false}
                placeholder={TEXT?.SELECT}
                disabled={false}
                type="big"
                onOpen={() => props?.setShowDatePicker?.(false)}
                onClose={() => props?.setShowDatePicker?.(false)}
              />
            </div>
          );
        case "year":
          return (
            <div className="flex flex-col gap-gap-xs">
              <p className="text-text-secondary text-font-xs">{`${field.name}${optionalLabel}`}</p>
              <SingleSelectDropDownComponent
                options={years}
                selected={field?.value || ""}
                setSelected={(val) => {
                  handleInputChange({
                    target: {
                      name: field.name,
                      value: val,
                      data_type: field?.data_type,
                    },
                  });
                }}
                isOpen={false}
                showSearch={false}
                placeholder={TEXT?.SELECT}
                disabled={false}
                type="big"
                onOpen={() => props?.setShowDatePicker?.(true)}
                onClose={() => props?.setShowDatePicker?.(false)}
              />
            </div>
          );

        case "quantity":
          const keyQuantity = `${field.name}_${field.data_type}`;
          const currentValueQuantity =
            props?.quantities?.[keyQuantity] || field?.value || 0;

          return (
            <div className="w-width-full flex flex-col gap-gap-xs">
              <p
                htmlFor={keyQuantity}
                id="uploadId"
                className={`text-font-xs ${
                  props?.isSingleDateSelected
                    ? "text-text-primary"
                    : "text-text-secondary"
                }`}
              >
                {`${field.name}${optionalLabel}`}
              </p>
              <CommonQuantity
                quantity={currentValueQuantity}
                setQuantity={(val) => {
                  props?.setQuantities?.((prev) => ({
                    ...prev,
                    [keyQuantity]: val,
                  }));

                  handleInputChange(
                    {
                      target: {
                        name: field.name,
                        value: val,
                      },
                    },
                    field?.data_type,
                  );
                }}
                isDisabled={false}
              />
            </div>
          );

        case "from_year_to_year":
          const keyYear = `${field.name}_${field.data_type}`;
          const currentYear = props?.selectedValue?.[keyYear] || {
            from: "",
            to: "",
          };

          const fromOptions = currentYear.to
            ? years.filter((year) => year <= currentYear.to)
            : years;

          const toOptions = currentYear.from
            ? years.filter((year) => year >= currentYear.from)
            : years;

          return (
            <div className="w-width-full">
              <div className="flex flex-row gap-gap-md w-width-full">
                <div className="w-width-md flex flex-col gap-gap-xs">
                  <p className="text-text-secondary text-font-xs">
                    {`${field.name}${optionalLabel}`}
                  </p>
                  <SingleSelectDropDownComponent
                    options={fromOptions}
                    selected={currentYear.from || ""}
                    setSelected={(value) => {
                      const updatedYear = { ...currentYear, from: value };

                      props?.setSelectedValue?.((prev) => ({
                        ...prev,
                        [keyYear]: updatedYear,
                      }));

                      handleInputChange(
                        { target: { name: field?.name, value: updatedYear } },
                        field?.data_type,
                      );
                    }}
                    type="big"
                    placeholder={TEXT?.SELECT}
                    isOpen={props.showYearDrop?.[`${keyYear}_from`] || false}
                    showSearch={false}
                    onOpen={() =>
                      props.setShowYearDrop({
                        [`${keyYear}_from`]: true,
                        [`${keyYear}_to`]: false,
                      })
                    }
                    onClose={() =>
                      props.setShowYearDrop((prev) => ({
                        ...prev,
                        [`${keyYear}_from`]: false,
                      }))
                    }
                  />
                </div>

                <div className="w-width-md flex flex-col gap-gap-xs">
                  <p className="text-text-secondary text-font-xs">
                    {`${field.name}${optionalLabel}`}
                  </p>

                  <SingleSelectDropDownComponent
                    options={toOptions}
                    selected={currentYear.to || ""}
                    setSelected={(value) => {
                      const updatedYear = { ...currentYear, to: value };

                      props?.setSelectedValue?.((prev) => ({
                        ...prev,
                        [keyYear]: updatedYear,
                      }));

                      handleInputChange(
                        { target: { name: field?.name, value: updatedYear } },
                        field?.data_type,
                      );
                    }}
                    type="big"
                    placeholder={TEXT?.SELECT}
                    isOpen={props.showYearDrop?.[`${keyYear}_to`] || false}
                    showSearch={false}
                    onOpen={() =>
                      props.setShowYearDrop({
                        [`${keyYear}_from`]: false,
                        [`${keyYear}_to`]: true,
                      })
                    }
                    onClose={() =>
                      props.setShowYearDrop((prev) => ({
                        ...prev,
                        [`${keyYear}_to`]: false,
                      }))
                    }
                  />
                </div>
              </div>
            </div>
          );
        case "month_year":
          const keyMonthYear = `${field.name}_${field.data_type}`;
          const currentMonthYear = props?.selectedValueMonth[keyMonthYear] || {
            month: "",
            year: "",
          };

          return (
            <div className="flex gap-gap-md w-width-full">
              <div className="flex-1 min-w-min-width-base flex flex-col gap-gap-xs">
                <p className="text-text-secondary text-font-xs">
                  {`${field.name}${optionalLabel}`}
                </p>
                <SingleSelectDropDownComponent
                  options={months}
                  selected={currentMonthYear.month || ""}
                  setSelected={(val) => {
                    props?.setSelectedValueMonth((prev) => ({
                      ...prev,
                      [keyMonthYear]: { ...prev[keyMonthYear], month: val },
                    }));
                    handleInputChange({
                      target: {
                        name: field?.name,
                        value: { ...currentMonthYear, month: val },
                      },
                    });
                  }}
                  isOpen={false}
                  showSearch={false}
                  placeholder={TEXT?.SELECT}
                  disabled={false}
                  type="big"
                  onOpen={() => props?.setShowDatePicker?.(false)}
                  onClose={() => props?.setShowDatePicker?.(false)}
                />
              </div>

              <div className="flex-1 min-w-min-width-base flex flex-col gap-gap-xs">
                <p className="text-text-secondary text-font-xs">
                  {`${field.name}${optionalLabel}`}
                </p>
                <SingleSelectDropDownComponent
                  options={years}
                  selected={currentMonthYear.year || ""}
                  setSelected={(val) => {
                    props?.setSelectedValueMonth((prev) => ({
                      ...prev,
                      [keyMonthYear]: { ...prev[keyMonthYear], year: val },
                    }));
                    handleInputChange({
                      target: {
                        name: field?.name,
                        value: { ...currentMonthYear, year: val },
                      },
                    });
                  }}
                  isOpen={false}
                  showSearch={false}
                  placeholder={TEXT?.SELECT}
                  disabled={false}
                  type="big"
                  onOpen={() => props?.setShowDatePicker?.(false)}
                  onClose={() => props?.setShowDatePicker?.(false)}
                />
              </div>
            </div>
          );

        case "date_range":
          const keyMultiDate = `${field.name}_${field.data_type}`;

          const currentValueFromDate = props?.startDate?.[keyMultiDate] ?? null;
          const currentValueToDate = props?.endDate?.[keyMultiDate] ?? null;

          return (
            <div className="w-width-full flex flex-col gap-gap-xs">
              <p className="text-text-secondary text-font-xs">
                {`${field.name}${optionalLabel}`}
              </p>

              <CommonCalendar
                selectionType="range"
                type="big"
                startDate={currentValueFromDate}
                endDate={currentValueToDate}
                handleDateChange={(dates) => {
                  handleDateChange(
                    dates,
                    keyMultiDate,
                    field?.name,
                    field?.data_type,
                  );
                }}
              />
            </div>
          );
        default:
          return null;
      }
    });
  };

  useEffect(() => {
    if (props.categoryIds.length === 1) {
      handleCategorySelect(props.categoryIds[0]);
    }
  }, []);

  return (
    <>
      <div
        className="max-w-tab-width-normal mx-auto w-width-full Qsmd:h-height-full h-auto px-padding-md Qlg:px-padding-base overflow-y-auto Qsmd:pt-padding-lg py-padding-md"
        style={{ scrollbarWidth: "none" }}
      >
        <CommonLayout>
          {!isArchive && (
            <div className="w-width-full lg:max-w-[var(--create-box-width)]">
              {isError ? null : (
                <CategorySelector
                  beneAccountId={beneAccountId}
                  category={props?.categoryIds}
                  selectedCategory={props?.selectedCategory}
                  // unassignCategories={unassignCategories}
                  unassignlength={unassignlength}
                  disableCategories={true}
                  handleCategorySelect={handleCategorySelect}
                  previewMode={false}
                  enableSearch={props.categoryIds.length !== 1}
                  showUnassignCTA={false}
                />
              )}
            </div>
          )}
          <div className="bg-primary-card py-padding-md h-auto flex flex-col px-padding-md items-start rounded-border-radius-md">
            <div className=" w-width-full text-text-primary font-semibold text-base flex flex-row justify-between">
              <p className="text-center pb-padding-xs">
                Category Specific Details
              </p>
            </div>
            <div className="w-width-full flex flex-col gap-gap-md">
              {props.isCategoryLoading ? (
                <div className="w-full flex justify-center items-center py-padding-md">
                  <Loader
                    width="var(--icon-lg)"
                    height="var(--icon-lg)"
                  />
                </div>
              ) : selectedCategory ? (
                renderInputFields()
              ) : (
                <div className="text-left text-text-secondary text-font-xs antialiased">
                  Select a category to fetch the category-specific details.
                </div>
              )}
            </div>
          </div>
        </CommonLayout>
      </div>

      {/* <div className="h-mobile-create-header w-width-full Qmd:hidden block my-margin-xl lg:my-margin-base"></div> */}
    </>
  );
};

export default ReimbursementRequestTxnAdditionalDetails;
